// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"872de133","117":"9f2ada16","217":"872de133","281":"0131bc68","335":"0abb8d49","394":"762706ad","438":"0242e66b","453":"762706ad","580":"41465bd1","676":"37b74cbf"}[chunkId] + ".chunk.css";
};